module.exports = __webpack_public_path__ + "public/SiteIcons/exitArrowIcon.svg?aaf6f63e";